// Vendor Components
import React, { Component } from 'react'
import styled, { ThemeProvider } from 'styled-components'
import Helmet from 'react-helmet'
import { StickyContainer } from 'react-sticky'
import axios from 'axios'

// Components
import Header from '../../header/header'
import Footer from '../../footer/footer'
import Menu from '../../menu/menu'
import ContactUs from '../../contactus/contactus'
import Welcome from '../../welcome/Welcome'
// Assets
import theme from '../../../styles/theme'

//Styles
import '../../../styles/global.scss'
import '../../../assets/css/bootstrap-grid.min.css'
import '../../../styles/ppm-font.scss'

const Container = styled.div`
  ${props => (props.blur ? 'filter: blur(4px)' : '')};
`

class Main extends Component {
  state = {
    menuIsOpen: false,
    contactIsOpen: false,
    welcomeIsOpen: false,
    currentStep: 1,
    name: '',
    primaryContact: {
      name: '',
      email: '',
      phone: ''
    },
    secondaryContact: {
      name: '',
      email: '',
      phone: ''
    },
    clientNumber: ''
  }

  componentDidMount() {
    const ppm = localStorage.getItem('ppm')
    const contactIsOpen =
      this.props.queryStr && this.props.queryStr.contact === 'open'
        ? true
        : false
    if (ppm) {
      this.setState({ welcomeIsOpen: false, contactIsOpen: contactIsOpen })
    } else {
      if (contactIsOpen) {
        this.setState({ welcomeIsOpen: false, contactIsOpen: contactIsOpen })
      } else {
        this.setState({ welcomeIsOpen: true, contactIsOpen: contactIsOpen })
      }
    }
  }

  _onContactFormSubmit = () => {
    let {
      name,
      clientNumber,
      ruc,
      channel,
      lopd,
      primaryContact,
      secondaryContact
    } = this.state

    axios({
      method: 'POST',
      url: process.env.API_URL,
      data: {
        campaign: process.env.API_CAMPAIGN,
        identification: ruc,
        company: name,
        name: name,
        features: channel,
        lopd,
        target: clientNumber,
        contacto1_nombre: primaryContact.name,
        contacto1_telefono: primaryContact.phone,
        contacto1_email: primaryContact.email,
        contacto2_nombre: secondaryContact.name,
        contacto2_telefono: secondaryContact.phone,
        contacto2_email: secondaryContact.email
      }
    })
      .then(() => {
        this._nextStep()
      })
      .catch(error => {
        console.log(error)
      })
  }

  _toggleMenu = menuIsOpen => {
    this.setState({ menuIsOpen, contactIsOpen: false, welcomeIsOpen: false })
    localStorage.setItem('ppm', true)
  }

  _toggleContact = contactIsOpen => {
    this.setState({
      contactIsOpen,
      menuIsOpen: false,
      welcomeIsOpen: false,
      currentStep: 1,
      name: '',
      ruc: '',
      primaryContact: {
        name: '',
        email: '',
        phone: ''
      },
      secondaryContact: {
        name: '',
        email: '',
        phone: ''
      },
      clientNumber: '',
      channel: 0,
      lopd: true
    })
    localStorage.setItem('ppm', true)
  }

  _closeWelcome = () => {
    this.setState({
      welcomeIsOpen: false,
      contactIsOpen: false,
      menuIsOpen: false
    })
    localStorage.setItem('ppm', true)
  }

  _nextStep = () => {
    let { currentStep } = this.state

    if (currentStep >= 5) {
      currentStep = 6
    } else {
      currentStep += 1
    }

    this.setState({
      currentStep
    })
  }

  _updateName = name => {
    this.setState({ name })
  }

  _updateRUC = ruc => {
    this.setState({ ruc })
  }
  _updateChannel = channel => {
    this.setState({ channel })
  }

  _updateLopd = lopd => {
    this.setState({ lopd })
  }

  _updatePrimaryContact = primaryContact => {
    this.setState({ primaryContact })
  }

  _updateSecondaryContact = secondaryContact => {
    this.setState({ secondaryContact })
  }

  _updateClientNumber = clientNumber => {
    this.setState({ clientNumber })
  }

  render() {
    const {
      name,
      ruc,
      primaryContact,
      secondaryContact,
      clientNumber,
      channel,
      lopd,
      currentStep,
      menuIsOpen,
      contactIsOpen,
      welcomeIsOpen
    } = this.state
    const { children, items } = this.props
    return (
      <div>
        <Helmet
          title="PPM :: Digital Business Developers"
          meta={[
            { name: 'description', content: 'Sample' },
            { name: 'keywords', content: 'sample, something' },
            {
              name: 'viewport',
              content: 'width=device-width, initial-scale=1.0'
            }
          ]}
        />
        <ThemeProvider theme={theme}>
          <StickyContainer>
            <Header
              isOpen={menuIsOpen}
              toggleMenu={this._toggleMenu}
              contactIsOpen={contactIsOpen}
              toggleContact={this._toggleContact}
              welcomeIsOpen={welcomeIsOpen}
            />
            <Container blur={menuIsOpen || contactIsOpen || welcomeIsOpen}>
              {children({
                menuIsOpen,
                contactIsOpen,
                toggleContact: this._toggleContact,
                welcomeIsOpen
              })}
            </Container>
            <Menu
              isOpen={menuIsOpen}
              toggleMenu={this._toggleMenu}
              items={items}
            />
            <ContactUs
              isOpen={contactIsOpen}
              currentStep={currentStep}
              nextStep={this._nextStep}
              toggleContact={this._toggleContact}
              updateName={this._updateName}
              updateRUC={this._updateRUC}
              updatePrimaryContact={this._updatePrimaryContact}
              updateSecondaryContact={this._updateSecondaryContact}
              updateChannel={this._updateChannel}
              updateLopd={this._updateLopd}
              updateClientNumber={this._updateClientNumber}
              name={name}
              clientNumber={clientNumber}
              channel={channel}
              lopd={lopd}
              primaryContact={primaryContact}
              secondaryContact={secondaryContact}
              ruc={ruc}
              clientNumber={clientNumber}
              onFormSubmit={this._onContactFormSubmit}
            />

            <Welcome
              isOpen={welcomeIsOpen}
              _closeWelcome={this._closeWelcome}
            />
            <Footer
              blur={menuIsOpen || contactIsOpen}
              contactIsOpen={contactIsOpen}
              toggleContact={this._toggleContact}
            />
          </StickyContainer>
        </ThemeProvider>
      </div>
    )
  }
}

export default Main



// WEBPACK FOOTER //
// ./src/components/container/main/main.js